import Vue from 'vue';
import Component from 'vue-class-component';
import { Mixins, Prop } from 'vue-property-decorator';
import { Section } from '@/courses/models/section.model';
import { ScreenMirroringMixin } from '@/screen-mirroring/mixins/screen-mirroring.mixin';
import { WidgetTeacherHomework } from '@/homework/models/widget-teacher-homework.model';
import { WidgetTeacherPerson } from '@/homework/models/widget-teacher-person.model';
import { HOMEWORK_STATUS } from '@/homework/values/homeworks.values';

@Component({
  name: 'ed-text-viewer',
  components: {
    EdTextViewerOnly: () => import('@/courses/components/ed-text-viewer-only/ed-text-viewer-only.vue')
  },
})
export default class EdTextViewer extends Mixins(ScreenMirroringMixin) {

  @Prop() readonly section: Section;
  @Prop() readonly courseId: number;
  @Prop() readonly canResponse: boolean;
  @Prop() readonly history: any;
  @Prop() readonly responseDraft: WidgetTeacherHomework;
  @Prop() readonly response: any;
  @Prop() readonly student: WidgetTeacherPerson;

  get isPresentationMode(): boolean {
    return this.$store.state.CourseStore.isPresentationStudentMode || this.$store.state.CourseStore.isPresentationTeacherMode;
  }

  get isHomework(): boolean {
    return Boolean(this.section?.homework || this.section?.section?.homework);
  }

  get openEditor(): boolean {
    return Boolean((this.isHomework && (this.isStudent || this.isPresentationMode)
      || (this.canResponse || this.responseDraft || this.homeworkResponse)
    ));
  }

  get homeworkResponse(): any {
    if (this.response) {
      return this.response;
    } else if (this.section?.homeworkInfo && this.section?.homeworkStatus !== HOMEWORK_STATUS.DRAFT) {
      return {
        ...this.section.homeworkInfo,
        assetsInfo: [this.section.homeworkInfo.homeworkAssetInfo]
      };
    }
  }

  get viewer() {
    return 'ed-text-viewer-only';
  }
}
